import React from 'react'
import { Button } from './'
import EditIcon from '../../assets/Images/icons/pencil-fill.svg'

const EditButton = (props) => {
  return (
    <Button {...props} rightIcon={EditIcon} />
  )
}

export default EditButton